export const appHead = {"meta":[{"charset":"utf-8"},{"name":"referrer","content":"no-referrer-when-downgrade"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"title","content":"SVALUE.APP — SHARING VALUE WHIT YOU!"},{"name":"author","content":"SValue - SVALUE.APP"},{"name":"name","content":"SValue - SVALUE.APP"},{"name":"keywords","content":"SValue -  Aggregate light-hearted and funny trending topics, Download APP, Follow Our X&Telegarm , Contact Us"},{"name":"applicable-device","content":"mobile"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"property":"og:type","content":"website"},{"property":"og:title","content":"SVALUE.APP — SHARING VALUE WHIT YOU!"},{"property":"og:description","content":"SValue -  Aggregate light-hearted and funny trending topics, Download APP, Follow Our X&Telegarm , Contact Us"},{"property":"og:image","content":"https://svalue.app/og.png"},{"property":"og:image:height","content":"1920"},{"property":"og:image:width","content":"1080"},{"property":"twitter:card","content":"summary_large_image"},{"property":"twitter:image","content":"https://svalue.app/og.png"},{"property":"twitter:title","content":"SVALUE.APP — SHARING VALUE WHIT YOU!"},{"property":"twitter:description","content":"SValue -  Aggregate light-hearted and funny trending topics, Download APP, Follow Our X&Telegarm , Contact Us"},{"property":"fb:app_id","content":"464031613279342"}],"link":[{"rel":"icon","href":"/svalue.ico","type":"image/x-icon"}],"style":[],"script":[{"src":"/telegram-web-app.js","type":"text/javascript"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true